// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dd31006766--wrapper--YWPgq","discount_price":"dd31006766--discount_price--ZiMof","hint":"dd31006766--hint--OMIk1"};